<template>

  <v-container fluid class="px-0 receiver-order-info-summary">

    <!-- Order Summary -->
    <order-summary
        class="page-content"
        :order="order" />

    <!-- Shipper and Receiver Info -->
    <v-container fluid class="page-content mt-4">
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" lg="6" class="pa-0">
          <order-shipper-info
              :title="(isCredit) ? 'Credit From' : 'Shipping From'"
              :order="order" />
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="6" class="pa-0">
          <order-receiver-info
              :title="(isCredit) ? 'Credit To' : 'Shipping To'"
              :order="order" />
        </v-col>
      </v-row>
    </v-container>

    <!-- Ordered Items -->
    <v-expansion-panels flat accordion class="mt-4" v-model="isShipmentDetailsActive">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="title">
            <span>{{ shipmentDetailsTitle }}</span>
            <span style="color:#9c9c9c;" class="pl-3">({{totalItems}})</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-4">
          <order-shipment-details
              class="mb-5"
              :order="order" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Order Invoice Viewer -->
    <order-invoice-viewer
        v-if="canViewInvoice"
        class="page-content mt-4"
        :order="order" />
  </v-container>

</template>

<script>
import OrderSummary from '@/components/orders/OrderSummary'
import OrderShipperInfo from '@/components/orders/OrderShipperInfo'
import OrderReceiverInfo from '@/components/orders/OrderReceiverInfo'
import OrderShipmentDetails from '@/components/orders/OrderShipmentDetails'
import OrderInvoiceViewer from '@/components/orders/OrderInvoiceViewer'

export default {
  name: 'ReceiverOrderInfoSummary',

  components: {
    OrderSummary,
    OrderShipperInfo,
    OrderReceiverInfo,
    OrderShipmentDetails,
    OrderInvoiceViewer
  },

  props: {
    orderId: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      isShipmentDetailsActive: false
    }
  },

  computed: {
    order () {
      return this.$parent.order
    },
    canViewInvoice () {
      return this.order.order_status !== 'BEING_SCHEDULED'
    },
    isCredit () {
      return this.order.is_credit
    },
    orderedItems () {
      return this.order.order_details.item_data.items
    },
    totalItems () {
      return this.orderedItems.length
    },
    shipmentDetailsTitle () {
      return (this.isCredit)
        ? 'Credited Items'
        : 'Ordered Items'
    },
    route () {
      return this.$parent.route
    },
    driver () {
      return (this.route) ? this.route.driver : null
    }
  },

  methods: {
    toggleShipmentView () {
      this.isShipmentDetailsActive = !this.isShipmentDetailsActive
    }
  }
}
</script>

<style>
  .receiver-order-info-summary .theme--dark.v-expansion-panels .v-expansion-panel {
    background-color: #161616;
    border: 1px solid #262626;
  }

  .receiver-order-info-summary .v-expansion-panel--active>.v-expansion-panel-header {
    min-height: unset;
  }

  .receiver-order-info-summary .v-expansion-panel-content__wrap {
    padding-left: 0px;
  }
</style>
